<template>
  <modal
    :header="true"
    :footer="false"
    :wide="isBig"
    :tall="isBig"
    class="google-connect-modal"
    @close="onSkip"
  >
    <template #modal-header>
      <div>
        {{ title }}
      </div>

      <button
        class="modal-close"
        data-test="mapdatamodal-button-close"
        @click="onSkip"
      >
        <span class="fal fa-times" />
      </button>
    </template>

    <template #modal-body>
      <google-sheets-map
        v-if="dataProvider.type === 'sheet-data'"
        v-model:title="title"
        v-bind="{ ...$props, ...$attrs }"
      />
      <sportradar-map
        v-else-if="dataProvider.type === 'sportradar'"
        v-model:title="title"
        v-bind="{ ...$props, ...$attrs }"
        @close="onSkip"
      />
    </template>
  </modal>
</template>

<script>
import Modal from './Modal.vue';
import GoogleSheetsMap from '../SettingsPanel/Data/GoogleSheets/MapModal.vue';
import SportradarMap from '../SettingsPanel/Data/Sportradar/AddData.vue';

export default {
  emits: ['skip'],
  inheritAttrs: false,
  components: {
    Modal,
    GoogleSheetsMap,
    SportradarMap,
  },
  props: {
    // The Data Provider element that contains connection metadata
    dataProvider: {
      required: true,
    },
    element: {
      required: true,
    },
    type: {
      required: false,
      default: 'text',
    },
  },
  data() {
    return {
      title: 'Map your data',
    };
  },
  computed: {
    isBig() {
      return this.dataProvider?.type === 'sportradar';
    },
  },
  methods: {
    onSkip() {
      this.$emit('skip');
    },
  },
};
</script>
